
export const shopInfoContainer = {
  companyNameTitle: 'YourCarpet.com',
  companyNameLegal: 'The Magic Carpets Company S.L.',
  baseURL: 'https://www.yourcarpet.com',
  address: {
    street: 'Av Luis Braille 18',
    city: 'Marbella',
    postalCode: '29670',
    country: 'Spain',
  },
  phone: '+34952788075',
  googleMapsPlaceID: 'ChIJK82HUz0qcw0Rs-Nf6tyIna4',
  socialMedia: {
    facebookPageURL: 'https://www.facebook.com/YourCarpetCom',
    pinterestPageURL: 'https://www.pinterest.com/YourCarpetCom',
    linkedinPageURL: 'https://www.linkedin.com/company/yourcarpetcom',
    twitterPageURL: 'https://www.x.com/Yourcarpetcom',
    tiktokPageURL: 'https://www.tiktok.com/@yourcarpet.com',
    instagramPageURL: 'https://www.instagram.com/yourcarpetcom/',
  }
}


export const allowedCountries = [
  'AL', 'DZ', 'AD', 'AR', 'AM', 'AU', 'AT', 'BR', 'BG', 'CA', 'CL', 'CN', 'HK',
  'MO', 'CO', 'CY', 'CZ', 'DK', 'EC', 'EG', 'SV', 'EE', 'FI', 'FR', 'GE', 'DE',
  'GI', 'GR', 'GL', 'HU', 'IS', 'IN', 'ID', 'IQ', 'IE', 'IM', 'IT', 'JP', 'JO',
  'KZ', 'KR', 'KW', 'KG', 'LV', 'LB', 'LI', 'LT', 'LU', 'MK', 'MY', 'MT', 'MX',
  'MD', 'MC', 'ME', 'MA', 'NL', 'NZ', 'NO', 'OM', 'PK', 'PS', 'PA', 'PY', 'PE',
  'PH', 'PL', 'PT', 'PR', 'QA', 'RO', 'RU', 'SA', 'SG', 'SK', 'SI', 'ZA', 'ES',
  'SE', 'CH', 'TW', 'TJ', 'TR', 'AE', 'GB', 'US', 'VE'];


export const daysOfWeek = {
  marbella: [
    { name: 'monday', hours: '10AM - 8PM', startTime: '10:00', endTime: '20:00' },
    { name: 'tuesday', hours: '10AM - 8PM', startTime: '10:00', endTime: '20:00' },
    { name: 'wednesday', hours: '10AM - 8PM', startTime: '10:00', endTime: '20:00' },
    { name: 'thursday', hours: '10AM - 8PM', startTime: '10:00', endTime: '20:00' },
    { name: 'friday', hours: '10AM - 8PM', startTime: '10:00', endTime: '20:00' },
    { name: 'saturday', hours: '10AM - 3PM', startTime: '10:00', endTime: '15:00' },
    { name: 'sunday', hours: 'Closed', startTime: '', endTime: '' }
  ],
  bilbao: [
    { name: 'monday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'tuesday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'wednesday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'thursday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'friday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'saturday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'sunday', hours: 'Closed', startTime: '', endTime: '' }
  ]
};
